import { render, staticRenderFns } from "./CandlePair.vue?vue&type=template&id=488fe58d&"
import script from "./CandlePair.vue?vue&type=script&lang=js&"
export * from "./CandlePair.vue?vue&type=script&lang=js&"
import style0 from "./CandlePair.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports